import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";

interface Request {
  url: string;
  data: Record<string, any>;
  method?: "post" | "patch";
}

const requestFun = async ({
  url,
  data,
  method = "patch",
}: Request): Promise<any> => {
  const response = await httpRequest[method](url, data);
  return response.data;
};

export const useAddAssetsLiabilities = () => {
  return useMutation<any, Error, Request>({
    mutationFn: requestFun,
  });
};
